/*

File handles all api calls for documents


*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Documents = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
        this.documentID = 0;
	},

    /**
    *
    * Retrieve all documents associated with user
    *
    */
	getDocuments: function(context) {
        var sortID = context.lastSortID;
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
        // #  Check for props on sort id
        if(sortID != "0") {
		    var url = "documents/" + sortID;
        } else {
		    var url = "documents";
        }
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
            // #  formatted data
            var formattedAttachmentData = [];
            response.data.map(function(data,index) {
                if(data.attachments != null){
                    // #  Has more than one objects
                    if(data.attachments.length > 1) {
                        data.attachments.map(function(inner_data,index) {
                            if(inner_data != null){
                                var prepare_attachment_data = {
                                    "belongTo": data.belongTo,
                                    "data": data.data,
                                    "attachments": [inner_data]
                                };
                                formattedAttachmentData.push(prepare_attachment_data);
                            }
                            return;
                        });
                    } else {
                        formattedAttachmentData.push(data);
                    }
                }
                return;
            });

			context.setState({attachmentData: formattedAttachmentData});
		})
		.fail(function(e){
			console.log(e);
		});
	},

	/**
	*
	* Deletes document(s)
	*
	*/
	deleteDocument: function(documentId, callback){
		// #  Localize this instance for use on success
      var self = this;
      // #  Send out success message
      modal.showDangerModalWithOK("Are you sure?","You are about to delete this file.","Yes, Delete");
      // #  Bind okay button
      jQuery(".move-on").on('click',function() {
		// prepare our data to be sent
		var url = "documents/" + documentId;
		// #  Send to server object for processing
		var data = self.server.getData(url,null,false, "DELETE");
	    // #  Listen to our data
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2)
          {
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
          }
          else
          {
			modal.resetBackDrop();
			modal.showInfo("Document Removed.", "success", "top", "center");
			if(callback) {
				callback();
			}
          }
        })
        .fail(function(e){
			console.log(e);
        });
      });
	},

	/**
	*
	* Saves documents
	*
	*/
	saveDocuments: function(context) {
		var self = this;
		// prepare our data to be sent
		var url = "tenants/" + self.tenantID;
		var params = context.state.tenantData;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				// #  Trigger file upload, if any data
				context.triggerUpload();
				modal.showSuccess("Tenant Updated!","This tenant has been updated.");
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},

    setDocumentID: function(documentID){
        this.documentID = documentID;
    }
});

export let documents = new Documents();


// WEBPACK FOOTER //
// app/core/controllers/Documents.js